<template>
    <div>
        <h3 v-b-tooltip.hover="`（${detailForm?.name}）`" class="text-truncate" style="position: absolute; top: -40px; left: 40px">
            （{{ detailForm?.name }}）
        </h3>
        <div class="card-header">
            <div class="d-flex">
                <div class="title--screen" style="white-space: nowrap">
                    {{ $t('managerForm.analytics.dataSerialCode') }}
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row justify-content-center">
                <div class="col-10">
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.serialCode') }}</label>
                        <div class="col">
                            <InputText
                                :model.sync="searchDataSerialCodeInit.search.serial_code"
                                :config.sync="configDataSerialCodeInit.search.serial_code"
                            />
                        </div>
                    </div>
                    <!-- <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.lotteryState') }}</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap">
                                <div v-for="item in LIST_LOTTERY_STATE" :key="item.id + '応募種別'">
                                    <InputCheckBox
                                        class="mr-3 mb-2"
                                        :model.sync="searchDataSerialCodeInit.filters.lottery_state"
                                        :id="`check-応募種別-${item.id}`"
                                        :value="item.id"
                                        :label="item.name"
                                    />
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.prizeName') }}</label>
                        <div class="col">
                            <InputText
                                :model.sync="searchDataSerialCodeInit.search.prize_title"
                                :config.sync="configDataSerialCodeInit.search.prize_title"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.prizeType') }}</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap">
                                <div v-for="item in LIST_PRIZE_TYPE" :key="item.id + '賞品種別'">
                                    <InputCheckBox
                                        class="mr-3 mb-2"
                                        :model.sync="searchDataSerialCodeInit.filters.prize_type"
                                        :id="`check-賞品種別-${item.id}`"
                                        :value="item.id"
                                        :label="item.name"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.lotteryDate') }}</label>
                        <div class="col-sm-9">
                            <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                <DateNormal :full_date.sync="searchDataSerialCodeInit.from.lottery_at" />
                                <p class="mb-0">{{ $t('history.from') }}</p>
                            </div>
                            <div class="d-flex align-items-center flex-wrap-reverse mb-2">
                                <DateNormal :full_date.sync="searchDataSerialCodeInit.to.lottery_at" />
                                <p class="mb-0">{{ $t('history.to') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.lotteryResult') }}</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap">
                                <div v-for="item in LIST_IS_WINNER" :key="item.id + '抽選結果'">
                                    <InputCheckBox
                                        class="mr-3 mb-2"
                                        :model.sync="searchDataSerialCodeInit.filters.is_winner"
                                        :id="`check-抽選結果-${item.id}`"
                                        :value="item.id"
                                        :label="item.name"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.productCode') }}</label>
                        <div class="col">
                            <InputText
                                :model.sync="searchDataSerialCodeInit.search.product_code"
                                :config.sync="configDataSerialCodeInit.search.product_code"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.personalUrl') }}</label>
                        <div class="col">
                            <InputText
                                :model.sync="searchDataSerialCodeInit.search.winner_uuid"
                                :config.sync="configDataSerialCodeInit.search.winner_uuid"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.settingPage.pageTypeB.registrationStatus') }}</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap">
                                <div v-for="item in LIST_REGISTRATION_STATUS" :key="item.id + '登録ステータス'">
                                    <InputCheckBox
                                        class="mr-3 mb-2"
                                        :model.sync="searchDataSerialCodeInit.filters.registration_status"
                                        :id="`check-登録ステータス-${item.id}`"
                                        :value="item.id"
                                        :label="item.name"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <template>
                        <div class="form-group row py-2 align-items-center" style="background-color: #e3e3e3; border-radius: 0.25rem">
                            <label class="col-sm-1 mb-0" style="min-width: 220px">【ブロック検索条件を結合する】</label>
                            <div class="px-3 flex-fill text-right">
                                <ButtonActiveFilter :active.sync="activeAccordions.searchBlocks" :smallCol="672" :largeCol="50" sizeBtn="sm" />
                            </div>
                        </div>
                        <div v-show="activeAccordions.searchBlocks">
                            <TableFilterBlock
                                ref="tableFilterBlock"
                                :blockList="[...listBlockForm, ...formAListBlock]"
                                :currentTypePage="detailForm?.type"
                                @onQuery="onHandleGetQueryTable"
                            />
                        </div>
                    </template>

                    <div class="text-center text-nowrap">
                        <button type="button" @click="handleClearSearch" class="btn btn-common btn-outline-primary">
                            <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
                        </button>
                        <button type="button" @click="handleExcuteSearch" class="btn btn-common btn-primary ml-3">
                            <i class="ri-search-line"></i>{{ $t('btn.search') }}
                        </button>
                    </div>
                </div>
            </div>

            <template>
                <h3 class="mb-0 title--screen">
                    回答結果 <span>件数 ({{ configPage.total }})</span>
                </h3>
                <div class="d-flex justify-content-end mb-2">
                    <button type="button" class="btn btn-common btn-success" @click="() => (configModalDownloadData.model = true)">
                        <i class="ri-file-download-line"></i>{{ $t('pageCampaign.dataDownload') }}
                    </button>
                </div>
                <TableListComponent
                    :heightTable="`calc(100vh - 600px)`"
                    :config="configTable"
                    :dataList="listDataTable"
                    :isLoading="isLoading"
                    :configPage.sync="configPage"
                    :stickyAction="true"
                    @onChangePage="getList()"
                    class="table-send-mail"
                >
                    <template #row="{ row }">
                        <tr>
                            <td class="text-left">{{ row.submit_index }}</td>
                            <td class="text-left el-table__cell">{{ row.serial_code }}</td>
                            <template v-for="(item, idx) in listBlockForm">
                                <td :key="`td-${idx}`" :style="getStyleDeletedCol(item.is_deleted)">
                                    <div class="el-table__cell text-left">
                                        <template v-if="item.block_type === ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE">
                                            <a
                                                target="_blank"
                                                :href="getValueBlockForm(row.submit_results, idx)?.path"
                                                v-b-tooltip.hover
                                                :title="getValueBlockForm(row.submit_results, idx)?.file_name"
                                                @click.prevent="
                                                    handleDownFile(
                                                        getValueBlockForm(row.submit_results, idx)?.path,
                                                        getValueBlockForm(row.submit_results, idx)?.file_name
                                                    )
                                                "
                                            >
                                                {{ getValueBlockForm(row.submit_results, idx)?.file_name }}
                                            </a>
                                        </template>
                                        <template v-else-if="item.block_type === ALL_BLOCK_TYPE.BLOCK_TEXTAREA">
                                            <div
                                                class="el-table__cell"
                                                v-b-tooltip.hover="{ title: getValueBlockForm(row.submit_results, idx), html: true }"
                                                v-html="renderLineBreaks(getValueBlockForm(row.submit_results, idx))"
                                            ></div>
                                        </template>
                                        <template v-else>
                                            <div class="el-table__cell" v-b-tooltip.hover :title="getValueBlockForm(row.submit_results, idx)">
                                                {{ getValueBlockForm(row.submit_results, idx) ?? '' }}
                                            </div>
                                        </template>
                                    </div>
                                </td>
                            </template>
                            <td class="text-left el-table__cell">{{ row?.lottery_pattern ?? '' }}</td>
                            <td class="text-left el-table__cell">{{ row?.prize?.title }}</td>
                            <td class="text-left el-table__cell">{{ row?.prize_type ?? '' }}</td>
                            <td>
                                <div class="text-left el-table__cell">
                                    {{ formatDateCommon(row?.lottery_at, 'dateTimeJP') }}
                                </div>
                            </td>
                            <td class="text-left el-table__cell">
                                {{ row.is_winner === 1 ? '当選' : '落選' }}
                            </td>
                            <td class="text-left el-table__cell">
                                <a v-if="regexUrl(row?.product?.code)" :href="row?.product?.code" target="_blank">{{ row?.product?.code }}</a>
                                <template v-else>{{ row?.product?.code }}</template>
                            </td>
                            <template v-for="key in productContentsKeysAdded">
                                <td :key="key" class="text-left el-table__cell">
                                    {{ getProductContentValue(row.product_contents, key) }}
                                </td>
                            </template>
                            <td class="text-left el-table__cell">
                                <a v-if="regexUrl(row?.personal_url)" :href="row?.personal_url" target="_blank">{{ row?.personal_url }}</a>
                                <template v-else>{{ row?.personal_url }}</template>
                            </td>
                            <td class="text-left el-table__cell">{{ row?.registration_status ?? '' }}</td>
                            <td>
                                <div class="el-table__cell">
                                    {{ formatDateCommon(row?.related_submit_result?.submitted_at, 'dateTimeJP') }}
                                </div>
                            </td>
                            <template v-for="(itemA, idxA) in formAListBlock">
                                <td :key="`info-form-a-${row?.related_submit_result?.id}-${itemA.id}`" :style="getStyleDeletedCol(itemA.is_deleted)">
                                    <div class="el-table__cell text-left">
                                        <template v-if="itemA.block_type === ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE">
                                            <a
                                                target="_blank"
                                                :href="getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A)?.path"
                                                v-b-tooltip.hover
                                                :title="
                                                    getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A)?.file_name
                                                "
                                                @click.prevent="
                                                    handleDownFile(
                                                        getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A)?.path,
                                                        getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A)?.file_name
                                                    )
                                                "
                                            >
                                                {{ getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A)?.file_name }}
                                            </a>
                                        </template>
                                        <template v-else-if="itemA.block_type === ALL_BLOCK_TYPE.BLOCK_TEXTAREA">
                                            <div
                                                class="el-table__cell"
                                                v-b-tooltip.hover="{
                                                    title: getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A),
                                                    html: true
                                                }"
                                                v-html="
                                                    renderLineBreaks(
                                                        getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A)
                                                    )
                                                "
                                            ></div>
                                        </template>
                                        <template v-else>
                                            <div
                                                class="el-table__cell"
                                                v-b-tooltip.hover
                                                :title="getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A)"
                                            >
                                                {{ getValueBlockForm(row?.related_submit_result?.submit_results, idxA, ID_PAGE_TYPE.A) ?? '' }}
                                            </div>
                                        </template>
                                    </div>
                                </td>
                            </template>
                            <template v-for="(item, idx) in listMailLogs">
                                <td :key="`td-addr-mail-${idx}`" :style="getStyleDeletedCol(item.is_deleted)">
                                    <div class="el-table__cell text-left">
                                        {{ getValueColumnMail(item, row?.related_submit_result?.email_logs)?.to_address }}
                                    </div>
                                </td>
                                <td :key="`td-status-mail-${idx}`" :style="getStyleDeletedCol(item.is_deleted)">
                                    <div class="el-table__cell text-left">
                                        {{ getValueColumnMail(item, row?.related_submit_result?.email_logs)?.status_label }}
                                    </div>
                                </td>
                            </template>
                        </tr>
                    </template>
                </TableListComponent>
            </template>
        </div>
        <ModalCommon id="ModalDownloadDataSerialCode" :config="configModalDownloadData" @close="() => (configModalDownloadData.model = false)">
            <DownloadData type="serial" :detailForm="detailForm" :queryTableFilter="getQueryString()" :configModal="configModalDownloadData" />
        </ModalCommon>
    </div>
</template>

<script>
import { formatDateCommon, handleDownFile, renderLineBreaks } from '@/utils/format';
import { configs } from '../../constants';
import { managerFormMethods } from '@/state/helpers';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { regexUrl } from '@/utils/regex';
import { InputCheckBox, InputText } from '@/components/Input';
import {
    initSearchDataSerialCode,
    initConfigDataSerialCode,
    LIST_LOTTERY_STATE,
    LIST_IS_WINNER,
    LIST_PRIZE_TYPE,
    LIST_REGISTRATION_STATUS
} from '@/views/pages/phase2/manager-form/analytics/components/data-serial-code/constants';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';
import {
    getValueColumnMail,
    handleSyncMailHeaders,
    handleSyncProductContentsHeaders,
    getFormattedHeader,
    getStyleDeletedCol
} from '@/views/pages/phase2/manager-form/analytics/handlers.js';

import TableListComponent from '@/components/TableList/main.vue';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import ModalCommon from '@/components/Modal/main.vue';
import DownloadData from '@/views/pages/phase2/manager-form/analytics/components/download-data/main.vue';
import TableFilterBlock from '@/views/pages/phase2/manager-form/analytics/components/manager-data/table-filter.vue';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';

export default {
    name: 'DataSerialCode',
    props: {
        detailForm: {
            type: Object,
            default: () => ({})
        }
    },
    components: { TableListComponent, InputText, InputCheckBox, DateNormal, ModalCommon, DownloadData, TableFilterBlock, ButtonActiveFilter },
    data() {
        return {
            ID_PAGE_TYPE,
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            configPage: configs.configPage,
            configModalDownloadData: configs.configModalDownloadData,
            configTable: configs.configTableSerialCode(),
            activeAccordions: configs.activeAccordions(),
            listDataTable: [],
            isLoading: false,
            listBlockForm: [],
            searchDataSerialCodeInit: initSearchDataSerialCode(),
            configDataSerialCodeInit: initConfigDataSerialCode(),
            LIST_LOTTERY_STATE,
            LIST_IS_WINNER,
            LIST_PRIZE_TYPE,
            LIST_REGISTRATION_STATUS,
            queryTableFilter: '',
            formAListBlock: [],
            listMailLogs: [],
            productContentsKeysAdded: []
        };
    },
    methods: {
        ...managerFormMethods,
        formatDateCommon,
        handleDownFile,
        regexUrl,
        renderLineBreaks,
        getValueColumnMail,
        getStyleDeletedCol,

        getProductContentValue(productContents, key) {
            if (!productContents || !Array.isArray(productContents)) return '';
            const content = productContents.find((item) => item.label === key);
            return content ? content.value : '';
        },

        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            let copyDataSearch = Object.assign({}, this.searchDataSerialCodeInit);
            for (const [key, value] of Object.entries(copyDataSearch)) {
                if (key && value) {
                    switch (key) {
                        case 'search':
                        case 'filters':
                        case 'from':
                        case 'to':
                            for (const [fromKey, fromValue] of Object.entries(value)) {
                                if (fromKey && (Array.isArray(fromValue) ? fromValue.length > 0 : fromValue || fromValue === 0))
                                    query.push(`${key}[${fromKey}]=${fromValue}`);
                            }
                            break;
                    }
                }
            }
            if (this.queryTableFilter) {
                query.push(this.queryTableFilter);
            }
            return query.join('&');
        },

        async getListBlockFromAnalytics() {
            try {
                const data = await this.getListBlockOfForm(this.$route.query.id);
                const sortedData = data?.sort((a, b) => a.order_index - b.order_index) ?? [];
                this.formAListBlock = sortedData.map((item) => {
                    return {
                        ...item,
                        ...getFormattedHeader(item),
                        submit_results: [],
                        options: item.list_options
                    };
                });
                this.configTable.headers.push(...this.formAListBlock);
            } catch (error) {
                console.log('error', error);
            }
        },

        async getListBlockFromSerialCode() {
            try {
                const data = await this.getListBlockOfFormSerial(this.$route.query.id);
                const filteredData =
                    data?.sort((a, b) => a.order_index - b.order_index).filter((item) => !item.extension.is_serial_code_type_b) ?? [];
                this.listBlockForm = filteredData.map((item) => {
                    return {
                        ...item,
                        ...getFormattedHeader(item),
                        submit_results: [],
                        options: item.list_options
                    };
                });
                this.configTable.headers.splice(2, 0, ...this.listBlockForm);
                this.configModalDownloadData.listBlockSerial = this.listBlockForm || [];
            } catch (error) {
                console.log('error', error);
            }
        },
        async getList() {
            let query = this.getQueryString();
            this.isLoading = true;
            try {
                const data = await this.getAnalyticsLottery({ id: this.$route.query.id, query: query });
                this.listDataTable = data.data.map((itemData) => {
                    itemData.related_submit_result?.submit_results.forEach((itemSubmit) => {
                        this.formAListBlock.forEach((itemBlock) => {
                            if (itemBlock.id === itemSubmit.block_id) {
                                itemBlock.submit_results.push(itemSubmit);
                            }
                        });
                    });
                    return itemData;
                });

                const { headers: productHeaders, productContentsKeysAdded } = handleSyncProductContentsHeaders(
                    data.data,
                    this.configTable.headers,
                    this.productContentsKeysAdded
                );
                this.configTable.headers = productHeaders;
                this.productContentsKeysAdded = productContentsKeysAdded;

                const { listMailLogs, headers } = handleSyncMailHeaders(data.data, this.formAListBlock, this.configTable.headers, ID_PAGE_TYPE.B);
                this.listMailLogs = listMailLogs;
                this.configTable.headers = headers;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listDataTable.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },
        getValueBlockForm(submitResults, index, typeForm = ID_PAGE_TYPE.B) {
            if (!submitResults || !Array.isArray(submitResults)) return '';
            let blockForm = {};
            switch (typeForm) {
                case ID_PAGE_TYPE.B:
                    blockForm = this.listBlockForm[index];
                    break;
                case ID_PAGE_TYPE.A:
                    blockForm = this.formAListBlock[index];
                    break;
            }
            const result = submitResults.find((item) => item.block_id === (blockForm.id || blockForm.block_id));
            const resultValue = result?.answers[0];
            const listValueToString =
                result?.answers
                    ?.map((item) => {
                        return item.is_custom_value ? `${result?.extension?.setting_others?.label_other}(${item.value ?? ''})` : item.value ?? '';
                    })
                    ?.toString() ?? '';
            switch (blockForm.block_type) {
                case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                    return resultValue?.file;
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    if (resultValue?.is_custom_value) {
                        return `${result?.extension?.setting_others?.label_other}(${resultValue.value ?? ''})`;
                    } else {
                        return result ? (Array.isArray(resultValue.value) ? resultValue.value.join(', ') : resultValue.value) : '';
                    }
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    return listValueToString;
                default:
                    return result ? (Array.isArray(resultValue.value) ? resultValue.value.join(', ') : resultValue.value) : '';
            }
        },

        handleClearSearch() {
            this.$refs.tableFilterBlock.handleClearSearch();
            this.searchDataSerialCodeInit = initSearchDataSerialCode();
            this.getList();
        },

        handleExcuteSearch() {
            this.$refs.tableFilterBlock.handleFilterResult();
        },

        onHandleGetQueryTable(query) {
            this.queryTableFilter = query;
            this.getList();
        }
    },
    async mounted() {
        this.isLoading = true;
        await this.getListBlockFromSerialCode();
        await this.getListBlockFromAnalytics();
        this.getList();
    }
};
</script>

<style lang="scss" scoped></style>
